import { Skeleton } from "@/components/ui/v2/skeleton";

export function NotificationRowSkeleton() {
  return (
    <div className="space-y-2 px-4 py-3">
      <Skeleton className="h-3 w-3/4" />
      <Skeleton className="h-3 w-1/3" />
    </div>
  );
}
